import { Period } from 'screens/Analytics/constants'
import { Select } from 'blaze-ui/Select/Select'
import { Calendar2 } from 'blaze-ui/icons'
import Styles from './PeriodSelect.module.scss'
import { ButtonVariant } from 'blaze-ui/Button/Types'
import { Item } from '@react-stately/collections'

export const PeriodSelect = ({
  period,
  onPeriodChange,
  variant,
}: {
  period: Period
  onPeriodChange: (period: Period) => void
  variant: ButtonVariant
}) => {
  return (
    <Select
      useChildClass
      aria-label="Select period"
      selectedKey={period}
      renderSelectValue={(selectedItem) => (
        <div className={Styles.selectValue}>
          <Calendar2 size={16} />
          {selectedItem.rendered}
        </div>
      )}
      onSelectionChange={(key) => onPeriodChange(key as Period)}
      variant={variant}
      aria-labelledby="Select period"
    >
      <Item key={Period.LastWeek}>Last 7 Days</Item>
      <Item key={Period.LastMonth}>Last 30 Days</Item>
      <Item key={Period.Last3Months}>Last 3 Months</Item>
      <Item key={Period.Last6Months}>Last 6 Months</Item>
      <Item key={Period.LastYear}>Last Year</Item>
    </Select>
  )
}
